import { render, staticRenderFns } from "./JournalReportWrapper.vue?vue&type=template&id=89335830&"
import script from "./JournalReportWrapper.vue?vue&type=script&lang=ts&"
export * from "./JournalReportWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports